import { render, staticRenderFns } from "./pushConfig.vue?vue&type=template&id=09c95cb2"
import script from "./pushConfig.vue?vue&type=script&lang=js"
export * from "./pushConfig.vue?vue&type=script&lang=js"
import style0 from "./pushConfig.vue?vue&type=style&index=0&id=09c95cb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports